import React, { useCallback, useEffect, useMemo } from "react";

import { notify } from "@cayuse/shared-react.components.banner-notification";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { useSFBComponents } from "hooks";

import styles from "./styles.css";

function TabsComponent (props) {
	const { config, id, onChange, currentTab } = props;
	const components = useSFBComponents();


	const onChangeTabContent = useCallback(content => {
		const t = currentTab;
		const getNewSections = prev => {
			const sections = prev.extraSettings.sections;
			sections[t] = { ...sections[t], ...content };

			return sections;
		};
		onChange(prev => ({
			...prev,
			extraSettings: {
				...prev.extraSettings,
				sections: getNewSections(prev),
			}
		}));
	}, [ onChange, currentTab ]);

	const Component = useMemo(
		() => {
			const currentTabType = config.extraSettings.sections[currentTab]?.type;

			return components[currentTabType];
		},
		[ components, config.extraSettings.sections, currentTab ]
	);

	useEffect(() => {
		if (!isNonEmptyArray(config.extraSettings.sections)) {
			notify("Form is invalid. Restore previous revision or import a new form.");
		}
	}, [ config.extraSettings.sections ]);

	if (Component === undefined) {
		return (
			<div className={styles.noResults}>
				<span>
					Invalid React element. Please check the component type.
				</span>
			</div>
		);
	}
	else if (isNonEmptyArray(config.extraSettings.sections)) {
		return (
			<div key={"tab-" + currentTab}>
				<Component
					{...props}
					id={`${id}.extraSettings.sections["${currentTab}"]`}
					config={config.extraSettings.sections[currentTab]}
					onChange={onChangeTabContent}
					currentTab={currentTab}
				/>
			</div>
		);
	}
	else {
		return (
			<div className={styles.noResults}>
				<span>
					No Sections Found
				</span>
			</div>
		);
	}
}

TabsComponent.showInPalette = () => false;

TabsComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"base-tabs",
			"Component"
		],
		stencilId: "cloud-tabs",
		customStencilId: "null"
	},
	type: "tabs",
	extraSettings: {
		sections: []
	}
});


export default TabsComponent;
